<template lang="html">
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.container {
}
</style>



// WEBPACK FOOTER //
// src/parts/layout/container.vue